/* Copyright (c) 2017 Backpack Health LLC */

/* global window, document, FileTransfer, cordova */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './MobileShareCardPdfViewer.styles.scss';

import ShareCardModel from '../../../../models/ShareCardModel';
import { GreenRedToggleSwitch } from '../../../components/ToggleSwitch';
import MobilePdfViewer from '../../../components/MobilePdfViewer';
import ShareCardService from '../../../../apiServices/ShareCardService';


interface Props {
  profileId: number;
  initialUrl: string;
  shareCard: ShareCardModel;
  languageCode: string;
  onDownload(urlEnabled: boolean): void;
  onShare(urlEnabled: boolean): void;
  close(): void;
}

interface State {
  includeUrl: boolean;
  url: string;
}

class MobileShareCardPdfViewer extends React.Component<Props, State> {

  state: State = {
    includeUrl: true,
    url: this.props.initialUrl,
  };

  pdfViewerRef: React.ReactFragment;

  constructor(props) {
    super(props);
    this.changePdfOptions = this.changePdfOptions.bind(this);
  }

  changePdfOptions() {
    const includeUrl = !this.state.includeUrl;
    const url = ShareCardService.getPdfUrl(
      this.props.profileId,
      this.props.shareCard.data.id,
      this.props.languageCode,
      includeUrl,
    );
    this.setState({
      includeUrl,
      url,
    }, () => {});
  }

  render() {
    const fileName = this.props.shareCard.title.get(this.props.languageCode);
    const includeUrl = this.props.shareCard.shareCardURL.isIncluded();
    return (
      <MobilePdfViewer
        ref={(r) => { this.pdfViewerRef = r; }}
        url={this.state.url}
        close={this.props.close}
        fileName={fileName}
        profileId={this.props.profileId}
        noHeader={false}
        noCache={true}
        footerHeight={60}
        onShare={() => this.props.onShare(includeUrl && this.state.includeUrl)}
        onDownload={() => this.props.onDownload(includeUrl && this.state.includeUrl)}
      >
        { (downloadProgress) =>
          includeUrl && (
            <div className="cmp-mobilesharecardpdfviewer-options font-body">
              <div style={{ whiteSpace: 'normal', textAlign: 'right' }}><FormattedMessage id="shareCardPDFPreview.includeURL.button.label" /></div>
              <GreenRedToggleSwitch
                disabled={downloadProgress}
                value={this.state.includeUrl}
                isOff={!this.state.includeUrl}
                choices={[{ name: 'includeUrl', label: '', value: false }, { name: 'includeUrl', label: '', value: true }]}
                onChange={this.changePdfOptions}
              />
            </div>
          )
        }
      </MobilePdfViewer>
    );
  }
}

export default MobileShareCardPdfViewer;
